import React from 'react'

import { Stack, Typography } from '@mui/material'
import { AutoCompleteBillingsParams } from 'models/Billings/AutoComplete'
import Image from 'next/image'

import GroupIcon from 'components/GroupIcon'

import { theme } from 'styles/theme'

const FALLBACK_COLOR = '#d8d8d8'

type GroupAutocompleteRecord = {
  uuid: string
  name: string
  customers_count?: number
  group_color?: string | null
  icon?: string | null
}

/** Converte um registro de /v1/customer_groups/autocomplete na opção dos seletores. */
export const toGroupOption = (
  record: GroupAutocompleteRecord
): AutoCompleteBillingsParams => ({
  label: record.name,
  value: record.uuid,
  customers_count: record.customers_count,
  group_color: record.group_color,
  icon: record.icon
})

export const participantsLabel = (count: number) => {
  if (count === 0) return 'Nenhum participante'
  return `${count} ${count === 1 ? 'participante' : 'participantes'}`
}

type GroupOptionProps = {
  liProps: React.HTMLAttributes<HTMLLIElement>
  option: AutoCompleteBillingsParams
}

/** Opção de grupo nos Autocompletes: ícone na cor do grupo, nome e nº de participantes. */
const GroupOption = ({ liProps, option }: GroupOptionProps) => (
  <Stack
    component="li"
    direction="row"
    alignItems="center"
    gap={1.5}
    {...liProps}
    key={option.value}
    sx={{
      cursor: 'pointer',
      ':hover': { backgroundColor: '#F2F5F2' },
      justifyContent: 'start !important',
      flexWrap: 'nowrap',
      py: '12px !important',
      px: '16px !important'
    }}
  >
    {!option.group_color && option.icon ? (
      <Image
        src={option.icon}
        alt=""
        width={32}
        height={32}
        style={{ borderRadius: '50%', flexShrink: 0 }}
      />
    ) : (
      <GroupIcon color={option.group_color || FALLBACK_COLOR} size={32} />
    )}
    <Stack minWidth={0} gap="2px">
      <Typography
        color={theme.palette.neutral[200]}
        fontWeight={600}
        fontSize="15px"
        noWrap
      >
        {option.label}
      </Typography>
      {option.customers_count !== undefined && (
        <Typography fontSize="12px" color="#777877">
          {participantsLabel(option.customers_count)}
        </Typography>
      )}
    </Stack>
  </Stack>
)

export default GroupOption
